import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import axios from 'axios';

const CLIENT_HEADER = 'X-Checkmate-Client';
const CLIENT_HEADER_VALUE = 'web';

export function apiRequest(resource, params, method, file = false) {
  let url = `${process.env.REACT_APP_API_URl}/${resource}`;
  if (method === 'get') {
    url += '?';
    let keys = Object.keys(params);
    for (let i = 0; i < keys.length; i++) {
      url += keys[i] + '=' + params[keys[i]] + '&';
    }
    params = {};
  }
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      data: params,
      responseType: file ? 'arraybuffer' : 'json',
      withCredentials: true,
      headers: {
        Accept: 'application/*, text/csv, image/*',
        'Content-Type': file ? 'application/pdf' : 'application/json',
        [CLIENT_HEADER]: CLIENT_HEADER_VALUE,
      },
    })
      .then(response => {
        if (file) resolve(response);
        else resolve(response.data);
      })
      .catch(error => {
        if (error.response) reject(error.response.data);
        else if (error.error) reject(error);
        else window.location.replace('/checkmate_error');
      });
  });
}

export const apiPartnerRequest = ({
  token,
  resource,
  params = {},
  method = 'GET',
  file = false,
}) => {
  let url = `${process.env.REACT_APP_API_URl}/partners/${resource}`;

  if (method === 'GET') {
    url += '?';
    let keys = Object.keys(params);
    for (let i = 0; i < keys.length; i++) {
      url += keys[i] + '=' + params[keys[i]] + '&';
    }
    params = {};
  }

  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      data: params,
      responseType: file ? 'arraybuffer' : 'json',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: token,
      },
    }).then(
      response => (file ? resolve(response) : resolve(response.data.result)),
      error => reject(error.response.data),
    );
  });
};

export default apiRequest;

export const toQueryParams = (params = {}) => {
  return Object.keys(params)
    .map(key => {
      const value = params[key] instanceof Array ? params[key].join(',') : params[key];
      return `${key}=${encodeURIComponent(value)}`;
    })
    .join('&');
};

export const createThunk = (type, uri, method = 'get') =>
  createAsyncThunk(type, async (params, { rejectWithValue }) => {
    try {
      const res = await apiRequest(uri, params || {}, method);
      return res.result;
    } catch (e) {
      return rejectWithValue(e);
    }
  });

export const createBaseQuery = (endpoint, options = {}) => {
  const { timeout = 10000 } = options;

  return fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URl}/${endpoint}`,
    timeout,
    credentials: 'include',
    prepareHeaders: headers => {
      headers.set(CLIENT_HEADER, CLIENT_HEADER_VALUE);
      return headers;
    },
  });
};

export const getFetchBaseQueryErrorMessage = error => {
  if (!error) {
    return '';
  }
  const data = error.data;
  if (data && typeof data === 'object' && data.error) {
    const { log, message } = data.error;
    if (log) {
      return log;
    }
    if (message) {
      return message;
    }
  }
  return typeof error.error === 'string' ? error.error : error.message || '';
};
